import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import * as React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useAccordionDndContext } from '../AccordionDndContext/AccordionDndContext.js';
import { useAccordionItemContext } from '../AccordionItemContext/AccordionItemContext.js';
import { jsx } from 'react/jsx-runtime';

var Context = /*#__PURE__*/React.createContext(null);
var AccordionItemDndContext = function AccordionItemDndContext(_ref) {
  var _children = _ref.children,
    dragIndex = _ref.dragIndex;
  var dndContext = useAccordionDndContext();
  var _useAccordionItemCont = useAccordionItemContext(),
    dragData = _useAccordionItemCont.dragData,
    itemId = _useAccordionItemCont.itemId;
  var dragItem = {
    itemId: itemId
  };
  React.useEffect(function () {
    dndContext === null || dndContext === void 0 ? void 0 : dndContext.setDragDataByItemId(itemId, dragData);
  }, [dndContext, itemId, dragData]);
  return /*#__PURE__*/jsx(Draggable, {
    isDragDisabled: !dndContext || !(dndContext !== null && dndContext !== void 0 && dndContext.canDrag) || !dndContext.canDrag(dragItem),
    draggableId: itemId,
    index: dragIndex,
    disableInteractiveElementBlocking: true,
    children: function children(draggableProvided, draggableSnapshot) {
      return /*#__PURE__*/jsx(Context.Provider, {
        value: {
          isDragging: draggableSnapshot.isDragging,
          dragHandleProps: _objectSpread({}, draggableProvided.dragHandleProps)
        },
        children: /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, draggableProvided.draggableProps), {}, {
          ref: draggableProvided.innerRef,
          children: _children
        }))
      });
    }
  }, itemId);
};
AccordionItemDndContext.displayName = "AccordionItemDndContext";
function useAccordionItemDndContext() {
  return React.useContext(Context);
}

export { AccordionItemDndContext, useAccordionItemDndContext };
